import React from 'react'
import { Divider, Grid, Stack, Typography } from '@mui/material'

const PlanSection = ({ title, subtitle }) => (
  <Grid item xs={12}>
    <Stack gap={0.5} sx={{ mt: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
      <Divider sx={{ mt: 0.5 }} />
    </Stack>
  </Grid>
)

export default React.memo(PlanSection)
